module.exports = __webpack_public_path__ + "media/images/icons/SVG/039-56d132945127a5f5459b1900fd6a9c77.svg";